const global_goods_data = {
    mall: [
        {
            name: 'navbar.bareMetal',
            filters: {
                industry: ['navbar.aiMachineLearning', 'navbar.finance', 'navbar.medical', 'navbar.education'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.11.0/mall-bms.png',
            link: '/detail/67877e797ef3564e50602182',
            index: 0
        },
        {
            name: 'navbar.cardTimeCapacity',
            filters: {
                industry: ['navbar.game', 'navbar.videoProcessing', 'navbar.rendering', 'navbar.scientificComputing'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.11.0/mall-storage.png',
            link: '/detail/6788c00ed3c12684dc1fc57c',
            index: 1
        },
        {
            name: 'navbar.tokenService',
            filters: {
                industry: ['navbar.nlp', 'navbar.computerVision', 'navbar.speech', 'navbar.recommendSystem'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.11.0/mall-general.png',
            link: '/detail/67d2796096a865edd37fa34f',
            index: 2
        },
        {
            name: 'navbar.traditionalPowerService',
            filters: {
                industry: ['navbar.dataAnalysis', 'navbar.websiteHosting', 'navbar.database', 'navbar.developmentTest'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.24.0/mall-ai.jpeg',
            link: '/detail/6788bff4d3c12684dc1fc57a',
            index: 3
        }
    ],
    aiService: [
        {
            name: 'navbar.dataAnnotation',
            filters: {
                industry: ['navbar.dataSet', 'navbar.industryData', 'navbar.frameworkPackage', 'navbar.other'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.24.0/mall-ai.jpeg',
            link: '/detail/6788bff4d3c12684dc1fc57a',
            index: 4
        },
        {
            name: 'navbar.industryModelFineTuning',
            filters: {
                industry: ['navbar.modelStructure', 'navbar.learningStrategy', 'navbar.dataPreprocessing', 'navbar.parameter', 'navbar.other'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.24.0/mall-ai.jpeg',
            link: '/detail/6788bff4d3c12684dc1fc57a',
            index: 5
        },
        {
            name: 'navbar.maasModelService',
            filters: {
                industry: ['navbar.nlp', 'navbar.computerVision', 'navbar.multiModal', 'navbar.speech', 'navbar.industryIntelligence', 'navbar.other'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.24.0/mall-ai.jpeg',
            link: '/detail/6788bff4d3c12684dc1fc57a',
            index: 6
        }
    ],
    product: [
        {
            name: 'navbar.server',
            filters: {
                industry: ['navbar.rackServer', 'navbar.aiSupercomputer', 'navbar.edgeServer', 'navbar.armServer', 'navbar.towerServer', 'navbar.highDensityServer'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.11.0/mall-bms.png',
            link: '/detail/67877e797ef3564e50602182',
            index: 7
        },
        {
            name: 'navbar.terminal',
            filters: {
                industry: ['navbar.game', 'navbar.videoProcessing', 'navbar.rendering', 'navbar.scientificComputing'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.11.0/mall-storage.png',
                link: '/detail/6788c00ed3c12684dc1fc57c',
            index: 8
        },
        {
            name: 'navbar.accessory',
            filters: {
                industry: ['navbar.nlp', 'navbar.computerVision', 'navbar.speech', 'navbar.recommendSystem'],
                region: ['navbar.northChina', 'navbar.eastChina', 'navbar.southChina', 'navbar.southwest']
            },
            path: 'https://accdn.accloud.cn/assets/images/ac6.24.0/mall-ai.jpeg',
            link: '/detail/6788bff4d3c12684dc1fc57a',
            index: 9
        }
    ]
}

const getMergedCategories = (t) => {
    const mallCategories = global_goods_data.mall.map(item => ({
        ...item,
        name: t(item.name),
        type: 'mall',
        filters: {
            industry: item.filters.industry.map(r => t(r)),
            region: item.filters.region.map(r => t(r))
        }
    }))
    
    const serverCategories = global_goods_data.aiService.map(item => ({
        ...item,
        name: t(item.name),
        type: 'aiService',
        filters: {
            industry: item.filters.industry.map(r => t(r)),
            region: item.filters.region.map(r => t(r))
        }
    }))

    const productCategories = global_goods_data.product.map(item => ({
        ...item,
        name: t(item.name),
        type: 'product',
        filters: {
            industry: item.filters.industry.map(r => t(r)),
            region: item.filters.region.map(r => t(r))
        }
    }))
    
    return [...mallCategories, ...serverCategories, ...productCategories]
    }

export { global_goods_data as default, getMergedCategories }